import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import Slide from '@mui/material/Slide'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { Grid, IconButton, Typography, useTheme } from '@mui/material'
import useClasses from '@/components/hooks/UseClasses'
import CircleCrossIcon from '@/components/icons/CircleCrossIcon'
import CircleCheckIcon from '@/components/icons/CircleCheckIcon'

const styles = () => ({
  grid: {
    display: 'grid',
    gap: '0.5rem',
    justifyItems: 'center',
    textAlign: 'center',
    margin: '2rem',
  },
})

const Snack = ({ text = null }) => {
  const { t } = useTranslation()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const theme = useTheme()
  const classes = useClasses(styles)
  const { message, variant } = useSelector(({ snack }) => snack)

  const [openModal, setOpenModal] = useState(false)

  const action = () => (
    <Button>
      <CloseIcon
        onClick={() => {
          closeSnackbar()
          dispatch({
            type: 'ERROR',
            payload: { message: '', variant: 'error' },
          })
        }}
      />
    </Button>
  )

  const handleCloseModal = () => {
    setOpenModal(false)
    dispatch({
      type: 'ERROR',
      payload: { message: '', variant: 'error' },
    })
  }

  const choseIconToShow = () => {
    if (variant === 'errorModal') {
      return <CircleCrossIcon />
    } else if (variant === 'okModal') {
      return <CircleCheckIcon />
    }
  }

  const choseHowShow = () => {
    let multi = false
    let msg = text ? text : message
    if (message?.split && message?.split(' ').length === 2) {
      msg = message.replace(' ', '.').toUpperCase()
    }
    if (message?.includes('/n')) {
      msg = 'ERROR.MULTIPLE'
    }
    if (message?.includes && message?.includes('|')) {
      multi = true
      msg = ''
      message.split('|').map((m, index) => {
        if (index === 0) {
          msg += t(m)
        } else if (index !== message.split('|').length - 1) {
          msg += t(m) + '. '
        } else {
          msg += t(m) + '.'
        }
      })
    }

    if (variant === 'errorModal' || variant === 'okModal') {
      setOpenModal(true)
    } else {
      let options = {
        variant: variant,
        persist: true,
        action,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        onClose: () => {
          dispatch({
            type: 'ERROR',
            payload: { message: '', variant: 'error' },
          })
        },
        TransitionComponent: Slide,
      }
      if (msg && !multi) {
        msg = t(msg)
        options = {
          ...options,
          variant: variant === 'moreinfo' ? 'info' : variant,
          persist: variant === 'error' || variant === 'moreinfo' ? true : false,
          autoHideDuration: variant !== 'error' && variant !== 'moreinfo' && 5000,
        }
      }
      if (msg) {
        enqueueSnackbar(<b>{msg}</b>, options)
      }
    }
  }

  useEffect(() => {
    choseHowShow()
  }, [message])

  return (
    <>
      <Dialog fullWidth maxWidth="lg" open={openModal} onClose={handleCloseModal}>
        <DialogTitle
          style={{
            height: '3.5rem',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.palette.background.primary.color,
          }}>
          <Typography variant="title_sm" style={{ color: theme.palette.text.light.color, margin: 'auto' }}>
            {'Aviso importante'}
          </Typography>
          <IconButton style={{ color: theme.palette.icon.light.color }} onClick={() => handleCloseModal()}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid className={classes.grid}>
            {choseIconToShow()}
            <Typography variant="title_md">{t(message)}</Typography>
          </Grid>
          <Grid
            style={{
              marginTop: 'auto',
              display: 'flex',
              justifyContent: 'center',
            }}>
            <Button variant={'bigSecondary'} onClick={() => handleCloseModal()} type={'button'}>
              {t('Cerrar')}
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default Snack
